// ! delete later
export const mockRailsAPI = formData => {
  // DELAY time to mimic server
  const DELAY = 500
  return new Promise((resolve, reject) => {
    // guard statement
    if (typeof formData !== 'object') {
      return setTimeout(
        () => reject(new Error('form data must be an object')),
        DELAY,
      )
    }
    // guard statement
    if (Object.keys(formData.params).length === 0) {
      return setTimeout(
        () =>
          reject(new Error('form data not found, must be wrapped in "params"')),
        DELAY,
      )
    }
    // sucess
    const results = { data: formData.params }
    setTimeout(() => resolve(results), DELAY)
  })
}
export const mockUser = {
  fullName: 'victor gervacio',
  id: 1,
  email: 'victorgervacio33@gmail.com',
  terms: [
    {
      id: 9,
      position: 'intern',
      title: 'builder',
      startDate: '2022-10-5',
      endDate: '2022-12-6',
      division: {
        id: 1,
        code: 'SWA',
      },
    },
  ],
}
export const mockUser2 = {
  fullName: 'john doe',
  id: 2,
  email: 'johnnydoe@gmail.com',
  terms: [
    {
      id: 8,
      position: 'intern',
      title: 'builder',
      startDate: '2022-6-5',
      endDate: '2022-10-4',
      division: {
        id: 1,
        code: 'SWA',
      },
    },
    {
      id: 9,
      position: 'crew_leader',
      title: 'boss',
      startDate: '2022-10-5',
      endDate: '2022-12-6',
      division: 'ACESolutions',
    },
  ],
}
// export const divisionList = [
//   { value: 'OPS', text: 'Operations' },
//   { value: 'SAM', text: 'Samoa' },
//   { value: 'PWC', text: 'Pacific West - California Central' },
//   { value: 'SEG', text: 'Southeast Gulf' },
//   { value: 'SEN', text: 'Southeast - North Carolina' },
//   { value: 'MTW', text: 'Mountain West - Utah' },
//   { value: 'PWS', text: 'Pacific West - California South' },
//   { value: 'PWN', text: 'Pacific West - California North' },
//   { value: 'BLM', text: 'Bureau of Land Management' },
//   { value: 'USF', text: 'US Forest Service' },
//   { value: 'NPS', text: 'National Park Service' },
//   { value: 'FWS', text: 'Fish and Wildlife Service' },
//   { value: 'BOR', text: 'Bureau of Reclamation' },
//   { value: 'SPE', text: 'Special Projects and Non-Profits' },
//   { value: 'NRC', text: 'Natural Resources Conservation Service' },
//   { value: 'SOL', text: 'ACE Solutions' },
//   { value: 'YCC', text: 'Youth Conservation Corps' },
//   { value: 'OOP', text: 'Office of the President' },
//   { value: 'ADM', text: 'Administration' },
//   { value: 'PRG', text: 'Program' },
//   { value: 'INT', text: 'International Program' },
//   { value: 'SWA', text: 'Southwest - Arizona' },
// ]
export const reimbursementOptions = [
  { text: '', value: null },
  { text: 'Housing', value: 'housing' },
  { text: 'Travel', value: 'travel' },
  { text: 'Uniforms', value: 'uniforms' },
  { text: 'Training', value: 'training' },
  { text: 'Safety Equipment', value: 'safety_equipment' },
  { text: 'Project Supplies', value: 'project_supplies' },
  { text: 'Vehicles', value: 'vehicles' },
]
export const feedbackOptions = [
  { text: '', value: null },
  { text: 'Question', value: 'question' },
  { text: 'Issue', value: 'issue' },
  { text: 'Feedback', value: 'feedback' },
]
